export default (function () {
    var navigation = document.querySelector(".mobile-navigation");
    var toggle = navigation && navigation.querySelector(".navigation--toggle .hamburger");
    var container = navigation && navigation.querySelector(".navigation--content");
    var menu = navigation && navigation.querySelector(".navigation--content > .menu-items");
    var menuItems = menu && menu.querySelector(".menu-items");
    var menuItem = menu && menu.querySelectorAll(".menu-item");
    if (toggle) {
        toggle.addEventListener("click", function () {
            toggle.classList.toggle("is-active");
            if (container) {
                container.classList.toggle("open");
            }
            if (menu) {
                menu.classList.toggle("open");
                if (!menu.classList.contains("open")) {
                    if (menuItems) {
                        menuItems.classList.remove("open");
                    }
                    if (container) {
                        container.classList.remove("open-child");
                    }
                }
            }
        });
    }
    if (menuItem) {
        menuItem.forEach(function (item) {
            var openButton = item.querySelector(".menu-item--open-children");
            if (openButton) {
                openButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var nextMenuList = item.querySelector(".menu-items");
                    console.log(nextMenuList);
                    if (nextMenuList) {
                        item.classList.toggle("open-child");
                        nextMenuList.classList.toggle("open");
                    }
                    if (container) {
                        container.classList.add("open-child");
                    }
                });
            }
        });
    }
});
